import {appActions, RequestStatuses} from './app-reducer'
import {ResponseType, ResultCodesEnum} from "./types";



export const withTryCatch = (operation: any, dispatch: any) => async () => {
    try {
        return await operation()
    } catch (error) {
        dispatch(appActions.setErrorMessage(error.message))
        dispatch(appActions.setRequestStatus(RequestStatuses.Error));
    }
    return null
}
export const withHandlingErrorResultCode = function <T>(operation: any, dispatch: any) {
    return async () => {
        let result: ResponseType<T> = await operation()
        if (result && result.resultCode && result.resultCode === ResultCodesEnum.Error && result.messages.length) {
            dispatch(appActions.setErrorMessage(result.messages[0]))
            dispatch(appActions.setRequestStatus(RequestStatuses.Error));
        }
    }
}
export const withProcessVisualization = function (operation: any, dispatch: any) {
    return async () => {
        dispatch(appActions.setRequestStatus(RequestStatuses.InProgress))
        await operation()
        dispatch(appActions.setRequestStatus(RequestStatuses.Success))
    }
}
export const commonAsyncHandler = function (operation: any, dispatch: any) {
    let handledErrorResultCode = withHandlingErrorResultCode(operation, dispatch)
    let tryCatched = withTryCatch(handledErrorResultCode, dispatch);
    let visualized = withProcessVisualization(tryCatched, dispatch)
    return visualized()
}
